module.exports = __webpack_public_path__ + "static/harry_potter-e026daf6a5943e636096a4ef7f2a47ab.gif";